import styled from 'styled-components';
import { styledByDevice } from '../../../../../themes/architecture/styled-by-device';
import { CssRule } from '../../../../../themes/architecture/css-helpers/css-rule';
import { WIDE_GRID } from '../../../../../themes/css-global-classes';

const DefaultBox = styled.div`
      position: relative;
      width: 40%;
      max-width: 20rem;
      margin-left: 0;
      margin-right: 3.5rem;
      overflow: visible;
      background-size: 100%;
      background-image: url("${props => props.theme.images.singleGame.defaultBackgroundImage.toString()}");
      background-repeat: no-repeat;

      &:after {
        content: "";
        background-image: url("${props => props.theme.images.verticalLineGlow.toString()}");
        background-repeat: no-repeat;
        background-size: contain;
        position: absolute;
        top: 0;
        height: 100%;
        transform: translateX(100%);
      }
`;


const PcBox = styled(DefaultBox)`
    &:after {
        right: -10px;
        width: 40px;

        ${CssRule.For.RTL.build()} & {
            right: 28px;
        }
    }


`;

const MobileBox = styled(DefaultBox)`


    @media ${({theme}) => theme.mediaQuery.mAndAbove} {
          &:after {
           right: -10px;
           width: 40px;
           ${CssRule.For.RTL.build()} & {
                right: 28px;
           }
        }
    }


    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
         &:after {
           right: -8%;
           width: 25px;

           ${WIDE_GRID} & {
                width: 40px;
            }

           ${CssRule.For.RTL.build()} & {
                right: 80%;
           }
         }
    }
`;

export const GameImageContainerDefaultBox = styledByDevice(PcBox, MobileBox);
